"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ONE_AND_ANOTHER = exports.BOTH = exports.DEBTOR_2 = exports.DEBTOR_1 = void 0;
var DEBTOR_1 = 'debtor1';
exports.DEBTOR_1 = DEBTOR_1;
var DEBTOR_2 = 'debtor2';
exports.DEBTOR_2 = DEBTOR_2;
var BOTH = 'both';
exports.BOTH = BOTH;
var ONE_AND_ANOTHER = 'one_and_another';
exports.ONE_AND_ANOTHER = ONE_AND_ANOTHER;